export default __webpack_public_path__ + "static/media/moon.0cbc266e.svg";